"use client"

// src/components/productos/Main.tsx
import type React from "react"
import { useEffect, useState, useMemo, useRef, useCallback } from "react"
import debounce from "lodash.debounce"
import { api, apiProductos } from "../../services/Axios"
import { useAuth } from "../../services/AuthContext"
import ConfirmationModal from "../utils/avisos/ConfirmationModal"
import MessageModal from "../utils/avisos/MessageModal"
import Loader from "../utils/loader/Loader"
import UploadExcel from "./UploadExcel"
import QRScanner from "./QRScanner"
import ReusableModal from "../utils/modals/ReusableModal"
import {
  FaBox,
  FaSearch,
  FaFilter,
  FaPlus,
  FaEye,
  FaEdit,
  FaTrash,
  FaMoneyBillWave,
  FaBoxOpen,
  FaChartLine,
  FaWeight,
  FaPercentage,
  FaTag,
  FaBuilding,
  FaTags,
  FaShoppingCart,
  FaArrowDown,
  FaArrowUp,
  FaCoins,
  FaQuestionCircle,
  FaTint,
  FaRuler,
  FaBarcode,
  FaChevronDown,
  FaChevronUp,
  FaFileExcel,
  FaTimes,
} from "react-icons/fa"
import PageHeader from "../ui/management/PageHeader"
import StatsCard from "../ui/management/StatsCard"
import Pagination from "../ui/management/Pagination"

export interface Product {
  _id: string
  codigo?: string
  nombre: string
  cantidad?: number
  unidadMedida?: "unidad" | "kg" | "gramo" | "litro" | "metro"
  umbral?: number
  fechaCaducidad?: Date
  categoria?: { _id: string; nombre: string }
  sucursal: { _id: string; nombre: string }
  marca?: { _id: string; nombre: string }
  proveedor?: { _id: string; nombre: string }
  referenciaProveedor?: string
  valorVenta: number
  valorVentaTotal: number
  valorCompra: number
  ivaPorcentaje?: number
  margenGanancia: number
  tipoCalculo?: 'recargo' | 'margen'
  inventariado?: boolean
  fechaInventariado?: Date
}

interface FilterOption {
  _id: string
  nombre: string
}

function ProductList() {
  const { userData } = useAuth()
  const [isReadOnlyMode, setIsReadOnlyMode] = useState<boolean>(false)

  const [productos, setProductos] = useState<Product[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null)

  const [modalOpen, setModalOpen] = useState(false)
  const [modalMessage, setModalMessage] = useState("")
  const [modalAction, setModalAction] = useState<(() => void) | null>(null)
  const [showMessageModal, setShowMessageModal] = useState(false)
  const [messageContent, setMessageContent] = useState("")
  const [messageType, setMessageType] = useState<"success" | "error" | "info" | "warning">("success")
  const [isSaving, setIsSaving] = useState<boolean>(false)

  const [searchTerm, setSearchTerm] = useState("")
  const [filterCategoria, setFilterCategoria] = useState("")
  const [filterMarca, setFilterMarca] = useState("")
  const [filterProveedor, setFilterProveedor] = useState("")
  const [filterSucursal, setFilterSucursal] = useState("")
  const [referenciaProveedor, setReferenciaProveedor] = useState("");
  // Estado para el campo de filtro de referencia de proveedor
  const [referenciaProveedorFilter, setReferenciaProveedorFilter] = useState("");
  const searchInputRef = useRef<HTMLInputElement>(null)
  const [sucursal, setSucursal] = useState("")

  const [nombre, setNombre] = useState("")
  const [codigo, setCodigo] = useState("")
  const [unidadMedida, setUnidadMedida] = useState<'unidad' | 'kg' | 'gramo' | 'litro' | 'metro'>('unidad')
  const [cantidad, setcantidad] = useState<string>("")
  const [umbral, setUmbral] = useState<number | string>("")
  const [valorVenta, setValorVenta] = useState<number | "">("")
  const [valorVentaTotal, setValorVentaTotal] = useState<number | "">("")
  const [fechaCaducidad, setFechaCaducidad] = useState("")
  const [categoria, setCategoria] = useState("")
  const [marca, setMarca] = useState("")
  const [proveedor, setProveedor] = useState("")
  
  const [nombreError, setNombreError] = useState("")
  const [codigoError, setCodigoError] = useState("")
  const [valorCompraError, setValorCompraError] = useState("")
  const [cantidadError, setcantidadError] = useState("")
  const [ivaPorcentajeError, setIvaPorcentajeError] = useState("")
  const [fechaCaducidadError, setFechaCaducidadError] = useState("")
  const [sucursalError, setSucursalError] = useState("")
  const [margenGananciaError, setMargenGananciaError] = useState("")

  const [valorCompra, setValorCompra] = useState<number | "">("")
  const [margenGanancia, setMargenGanancia] = useState<number | "">("")
  const [ivaPorcentaje, setIvaPorcentaje] = useState<number | "">("")
  const [tipoCalculo, setTipoCalculo] = useState<'recargo' | 'margen'>('recargo')

  const productsPerPage = 6
  const [totalPages, setTotalPages] = useState(1)
  const [totalProductos, setTotalProductos] = useState(0)
  const [currentPage, setCurrentPage] = useState<number>(1)

  const [totalCompra, setTotalCompra] = useState(0)
  const [totalGanancia, setTotalGanancia] = useState(0)
  const [totalValorFiltrado, setTotalValorFiltrado] = useState(0)
  const [totalCantidadUnidades, setTotalCantidadUnidades] = useState(0)

  const [isExpanded, setIsExpanded] = useState(false)

  const [isQRScannerOpen, setIsQRScannerOpen] = useState(false)
  const [showUploadExcel, setShowUploadExcel] = useState(false)

  const [isAddingCategoria, setIsAddingCategoria] = useState(false);
  const [newCategoriaNombre, setNewCategoriaNombre] = useState("");
  const [isAddingProveedor, setIsAddingProveedor] = useState(false);
  const [newProveedorNombre, setNewProveedorNombre] = useState("");
  const [isAddingMarca, setIsAddingMarca] = useState(false);
  const [newMarcaNombre, setNewMarcaNombre] = useState("");

  const [categories, setCategories] = useState<FilterOption[]>([])
  const [brands, setBrands] = useState<FilterOption[]>([])
  const [suppliers, setSuppliers] = useState<FilterOption[]>([])
  const [sucursales, setSucursales] = useState<FilterOption[]>([])

  const [filterInventariado, setFilterInventariado] = useState<string>("")

  const hasActiveFilters = searchTerm !== '' || filterCategoria !== '' || filterMarca !== '' || filterProveedor !== '' || filterSucursal !== '' || referenciaProveedorFilter !== '' || filterInventariado !== ''
  const filterCount = [filterCategoria, filterMarca, filterProveedor, filterSucursal, referenciaProveedorFilter, filterInventariado].filter(v => v !== '').length
  
  useEffect(() => {
    const calcularValores = () => {
      if (typeof valorCompra === "number" && valorCompra > 0) {
        const valorVentaCalculado =
          userData?.organization?.responsableIVA && typeof ivaPorcentaje === "number"
            ? valorCompra * (1 + ivaPorcentaje / 100)
            : valorCompra

        setValorVenta(Math.round(valorVentaCalculado))

        if (typeof margenGanancia === "number" && margenGanancia > 0) {
          let valorVentaTotalCalculado: number

          if (tipoCalculo === 'margen') {
            // Margen sobre venta: costo / (1 - margen/100)
            // Validación: porcentaje < 100 para evitar división por cero o negativo
            if (margenGanancia >= 100) {
              setValorVentaTotal("")
              return
            }
            valorVentaTotalCalculado = valorVentaCalculado / (1 - margenGanancia / 100)
          } else {
            // Recargo sobre costo: costo * (1 + margen/100)
            valorVentaTotalCalculado = valorVentaCalculado * (1 + margenGanancia / 100)
          }

          setValorVentaTotal(Math.round(valorVentaTotalCalculado))
        } else {
          setValorVentaTotal("")
        }
      } else {
        setValorVenta("")
        setValorVentaTotal("")
      }
    }

    calcularValores()
  }, [valorCompra, ivaPorcentaje, margenGanancia, tipoCalculo, userData?.organization?.responsableIVA])
  
  const fetchProducts = useCallback(
    (page: number, filters: { [key: string]: any }) => {
      setIsLoading(true);
      apiProductos
        .get("/api/productos", {
          params: {
            page,
            limit: productsPerPage,
            ...filters,
          },
        })
        .then((response) => {
          const { productos, totalPages, totalProductos, indicadores } = response.data
          setProductos(productos)
          setTotalPages(totalPages)
          setTotalProductos(totalProductos)

          // Actualizar indicadores globales
          setTotalCompra(indicadores.totalCompra)
          setTotalGanancia(indicadores.totalGanancia)
          setTotalValorFiltrado(indicadores.totalValorVenta)
          setTotalCantidadUnidades(indicadores.totalCantidadUnidades)
        })
        .catch((error) => console.error("Error al obtener productos:", error))
        .finally(() => setIsLoading(false));
    },
    [productsPerPage],
  );

  const debouncedFetch = useMemo(
    () => debounce((filters) => {
      fetchProducts(1, filters);
    }, 500),
    [fetchProducts]
  );

  // Crea el objeto filters con useMemo para evitar recrearlo en cada render
  const filters = useMemo(() => ({
    searchTerm,
    sucursal: filterSucursal || undefined,
    categoria: filterCategoria || undefined,
    marca: filterMarca || undefined,
    proveedor: filterProveedor || undefined,
    referenciaProveedor: referenciaProveedorFilter || undefined,
    inventariado: filterInventariado || undefined, // NUEVO
  }), [searchTerm, filterSucursal, filterCategoria, filterMarca, filterProveedor, referenciaProveedorFilter, filterInventariado]);

  // Este useEffect solo escucha los cambios de los filtros de la tabla
  useEffect(() => {
    setCurrentPage(1); // Resetea a página 1 cuando cambian los filtros
    debouncedFetch(filters);
  }, [filters, debouncedFetch]);

  // Este useEffect solo maneja el cambio de página
  useEffect(() => {
    fetchProducts(currentPage, filters);
  }, [currentPage, fetchProducts, filters]);
  
  const fetchFilters = () => {
    Promise.all([
      api.get("/api/categorias"),
      api.get("/api/marcas"),
      api.get("/api/proveedores"),
      api.get("/api/sucursales"),
    ])
      .then(([catRes, brandRes, supplierRes, sucursalRes]) => {
        setCategories(catRes.data.categorias || [])
        setBrands(brandRes.data.marcas || [])
        setSuppliers(supplierRes.data.proveedores || [])
        setSucursales(sucursalRes.data.sucursales || [])
      })
      .catch((error) => console.error("Error al obtener filtros:", error))
  }

  useEffect(() => {
    fetchFilters()
  }, [])

  const debouncedSearch = useMemo(
    () =>
      debounce((value: string) => {
        setSearchTerm(value)
      }, 500),
    [],
  )

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(e.target.value)
  }

  const clearFilters = () => {
    setSearchTerm("")
    setFilterCategoria("")
    setFilterMarca("")
    setFilterProveedor("")
    setFilterSucursal("")
    setReferenciaProveedorFilter("") 
    setFilterInventariado("")
    if (searchInputRef.current) {
      searchInputRef.current.value = ""
    }
  }

  const clearFields = () => {
    setNombre("")
    setCodigo("")
    setUnidadMedida("unidad")
    setcantidad("")
    setUmbral("")
    setValorVenta("")
    setFechaCaducidad("")
    setCategoria("")
    setMarca("")
    setProveedor("")
    setReferenciaProveedor("") // Limpia el estado del modal
    setSucursal("")
    setValorCompra("")
    setMargenGanancia("")
    setIvaPorcentaje("")
    setTipoCalculo("recargo")
  }

  const openConfirmationModal = (message: string, action?: () => void) => {
    setModalMessage(message)
    setModalAction(() => action || closeModal)
    setModalOpen(true)
  }

  const closeModal = () => {
    setModalOpen(false)
    setModalAction(null)
    setModalMessage("")
  }

  const handleAddProduct = () => {
    setIsEditMode(false)
    setIsModalOpen(true)
    clearFields()
    clearErrors()
  }

  const handleViewProduct = (product: Product) => {
    setSelectedProduct(product)
    setNombre(product.nombre || "")
    setCodigo(product.codigo || "")
    setUnidadMedida(product.unidadMedida || "unidad")
    setcantidad(product.cantidad?.toString() || "")
    setUmbral(product.umbral ?? "")
    setValorVenta(product.valorVenta ?? "")
    setValorCompra(product.valorCompra ?? "")
    setIvaPorcentaje(product.ivaPorcentaje ?? 0)
    setMargenGanancia(product.margenGanancia ?? "")
    setTipoCalculo(product.tipoCalculo ?? 'recargo')
    setValorVentaTotal(product.valorVentaTotal ?? "")
    setFechaCaducidad(product.fechaCaducidad ? new Date(product.fechaCaducidad).toISOString().slice(0, 10) : "")
    setCategoria(product.categoria ? product.categoria._id : "")
    setMarca(product.marca ? product.marca._id : "")
    setProveedor(product.proveedor ? product.proveedor._id : "")
    setReferenciaProveedor(product.referenciaProveedor || "")
    setSucursal(product.sucursal ? product.sucursal._id : "")
    setIsEditMode(false)
    setIsReadOnlyMode(true)
    setIsModalOpen(true)
    clearErrors()
  }

  const handleEditProduct = (product: Product) => {
    setSelectedProduct(product)
    setNombre(product.nombre || "")
    setCodigo(product.codigo || "")
    setUnidadMedida(product.unidadMedida || "unidad")
    setcantidad(product.cantidad?.toString() || "")
    setUmbral(product.umbral ?? "")
    setValorVenta(product.valorVenta ?? "")
    setValorCompra(product.valorCompra ?? "")
    setIvaPorcentaje(product.ivaPorcentaje ?? 0)
    setMargenGanancia(product.margenGanancia ?? "")
    setTipoCalculo(product.tipoCalculo ?? 'recargo')
    setValorVentaTotal(product.valorVentaTotal ?? "")
    setFechaCaducidad(product.fechaCaducidad ? new Date(product.fechaCaducidad).toISOString().slice(0, 10) : "")
    setCategoria(product.categoria ? product.categoria._id : "")
    setMarca(product.marca ? product.marca._id : "")
    setProveedor(product.proveedor ? product.proveedor._id : "")
    setReferenciaProveedor(product.referenciaProveedor || "")
    setSucursal(product.sucursal ? product.sucursal._id : "")
    setIsEditMode(true)
    setIsModalOpen(true)
    clearErrors()
  }

  const handleSaveProduct = () => {
    let hasError = false

    if (!nombre.trim()) {
      setNombreError("Nombre es obligatorio")
      hasError = true
    } else setNombreError("")

    if (!codigo.trim()) {
      setCodigoError("Código es obligatorio")
      hasError = true
    } else setCodigoError("")

    if (!sucursal) {
      setSucursalError("Sucursal es obligatoria")
      hasError = true
    } else setSucursalError("")

    if (!cantidad) {
      setcantidadError("Valor Cantidad es obligatorio")
      hasError = true
    } else setcantidadError("")

    if (!valorCompra) {
      setValorCompraError("Valor Compra es obligatoria")
      hasError = true
    } else setValorCompraError("")

    if (!margenGanancia) {
      setMargenGananciaError("Margen de Ganancia es obligatorio")
      hasError = true
    } else if (tipoCalculo === 'margen' && Number(margenGanancia) >= 100) {
      setMargenGananciaError("Con margen sobre venta el porcentaje debe ser menor a 100%")
      hasError = true
    } else setMargenGananciaError("")

    // Validación para `ivaPorcentaje` solo si es responsable de IVA
    if (userData?.organization?.responsableIVA && ivaPorcentaje === "") {
      setIvaPorcentajeError("% IVA es obligatorio")
      hasError = true
    } else setIvaPorcentajeError("")

    if (hasError) return

    const saveAction = () => {
      if (isSaving) return; // 🔒 Previene múltiples ejecuciones
      setIsSaving(true)
      const categoriaValue = categoria || null
      const marcaValue = marca || null
      const proveedorValue = proveedor || null

      const cantidadValue = cantidad === "" ? null : Number(cantidad)

      const productData = {
        nombre,
        codigo,
        cantidad: cantidadValue,
        unidadMedida,
        umbral,
        fechaCaducidad: fechaCaducidad ? new Date(fechaCaducidad) : undefined,
        valorVenta,
        valorVentaTotal,
        ivaPorcentaje: userData?.organization?.responsableIVA ? ivaPorcentaje : undefined,
        valorCompra,
        margenGanancia,
        tipoCalculo,
        categoria: categoriaValue,
        marca: marcaValue,
        proveedor: proveedorValue,
        referenciaProveedor: referenciaProveedor || null,
        sucursal,
      }

      const action = isEditMode
        ? apiProductos.put(`/api/productos/${selectedProduct?._id}`, productData)
        : apiProductos.post("/api/productos/add", productData)

      action
        .then(() => {
          // Muestra el mensaje de éxito
          setMessageContent(isEditMode ? "Producto actualizado exitosamente." : "Producto agregado exitosamente.")
          setMessageType("success")
          setShowMessageModal(true)
          setIsModalOpen(false)
          setReferenciaProveedor("")
          // Refrescar los productos después de guardar
          fetchProducts(currentPage, {
            searchTerm,
            sucursal: filterSucursal || undefined,
            categoria: filterCategoria || undefined,
            marca: filterMarca || undefined,
            proveedor: filterProveedor || undefined,
            referenciaProveedor: ""
          })
        })
        .catch((error) => {
          // Muestra el mensaje de error si algo falla
          const errorMessage = error.response?.data?.msg || "Error al guardar el producto."
          setMessageContent(errorMessage)
          setMessageType("error")
          setShowMessageModal(true)
        })
        .finally(() => {
          setIsSaving(false)
          closeModal()
        })
    }

    // Ejecuta saveAction en el modal de confirmación
    openConfirmationModal(
      isEditMode
        ? "¿Deseas guardar los cambios realizados en este producto?"
        : "¿Estás seguro de agregar este nuevo producto?",
      saveAction,
    )
  }

  const clearErrors = () => {
    setNombreError("")
    setCodigoError("")
    setcantidadError("")
    setValorCompraError("")
    setMargenGananciaError("")
    setIvaPorcentajeError("")
    setFechaCaducidadError("")
    setSucursalError("")
  }

  const handleDeleteProduct = (productId: string) => {
    openConfirmationModal("¿Está seguro de que desea eliminar este producto?", () => {
      apiProductos
        .delete(`/api/productos/${productId}`)
        .then(() => {
          setMessageContent("Producto eliminado exitosamente.")
          setMessageType("success")
          setShowMessageModal(true)
          // Refrescar los productos después de eliminar
          fetchProducts(currentPage, {
            searchTerm,
            sucursal: filterSucursal || undefined,
            categoria: filterCategoria || undefined,
            marca: filterMarca || undefined,
            proveedor: filterProveedor || undefined,
            referenciaProveedor: referenciaProveedorFilter || undefined,
          })
        })
        .catch(() => {
          setMessageContent("Error al eliminar el producto.")
          setMessageType("error")
          setShowMessageModal(true)
        })
        .finally(() => closeModal())
    })
  }

  const handleCloseMessageModal = () => {
    setShowMessageModal(false)
    closeModal()
  }

  const handleNumericInput = (input: string) => {
    const numericValue = input.replace(/[^0-9.]/g, "") // permite solo números y un punto decimal
    return numericValue
  }

  const handleUmbralChange = (val: string) => {
    const sanitizedValue = val.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1") // Permitir solo números y un punto decimal
    setUmbral(sanitizedValue) // Actualiza umbral con valor decimal
  }

  // Campos específicos si es responsable de IVA
  const ivaFields = userData?.organization?.responsableIVA
    ? [
        {
          label: "% IVA",
          value: ivaPorcentaje?.toString() || "",
          onChange: (val: string) => setIvaPorcentaje(Number(val)),
          required: true,
          readOnly: isReadOnlyMode,
          error: ivaPorcentajeError, // Cambiado a string
        },
        {
          label: "Valor Venta (con IVA)",
          value: valorVenta?.toString() || "",
          onChange: () => {}, // Solo lectura
          readOnly: true,
        },
      ]
    : []

  
  const unidadLabelMap: Record<string, string> = {
    unidad: "Unidad",
    kg: "Kg",
    gramo: "Gramo",
    litro: "Litro",
    metro: "Metro",
  }

  const cantidadValorLabel = `Cantidad en ${unidadLabelMap[unidadMedida] || unidadMedida}`
  const umbralLabel = `Umbral por ${unidadLabelMap[unidadMedida] || unidadMedida}`
  const valorCompraLabel = `Valor Compra por ${unidadLabelMap[unidadMedida] || unidadMedida}`
  const valorVentaTotalLabel = `Valor Venta Total por ${unidadLabelMap[unidadMedida] || unidadMedida}`

  // Campo para margen de ganancia y valor venta total
  const gananciaFields = [
    {
      label: (
        <div className="flex items-center gap-2">
          <span>Tipo de Cálculo</span>
          <span
            className="text-gray-400 cursor-pointer"
            title="Recargo sobre costo: le sumas un % al costo. Ej: costo $1.000 + 30% = vendes en $1.300 (ganas $300). | Margen sobre venta: el % es tu ganancia sobre el precio final. Ej: margen 30% sobre $1.000 = vendes en $1.429. Si no sabes cuál usar, elige Recargo sobre costo."
          >
            <FaQuestionCircle />
          </span>
        </div>
      ),
      value: tipoCalculo,
      onChange: (val: string) => setTipoCalculo(val as 'recargo' | 'margen'),
      type: "select" as const,
      options: [
        { value: 'recargo', label: 'Recargo sobre Costo' },
        { value: 'margen', label: 'Margen sobre Venta' },
      ],
      readOnly: isReadOnlyMode,
    },
    {
      label: tipoCalculo === 'margen'
        ? "Margen sobre Venta (%)"
        : "Margen de Ganancia (%)",
      value: margenGanancia?.toString() || "",
      onChange: (val: string) => setMargenGanancia(Number(val)),
      required: true,
      readOnly: isReadOnlyMode,
      error: margenGananciaError,
    },
    {
      label: valorVentaTotalLabel,
      value: valorVentaTotal?.toString() || "",
      onChange: () => {},
      readOnly: true,
    },
  ]

  // Agrega estas funciones dentro del componente ProductList

  const handleAddNewCategoria = async () => {
    if (!newCategoriaNombre.trim()) return;
    try {
      const response = await api.post("/api/categorias/add", { nombre: newCategoriaNombre });
      const nuevaCategoria = response.data.categoria; // El backend debe devolver { categoria: {...} }

      // --- VALIDACIÓN AÑADIDA ---
      if (nuevaCategoria && nuevaCategoria._id) {
        setCategories([...categories, nuevaCategoria]);
        setCategoria(nuevaCategoria._id); // Selecciona la nueva categoría
        setMessageContent("Categoría agregada exitosamente.");
        setMessageType("success");
      } else {
        // Si la API no devuelve lo esperado, refrescamos la lista completa
        fetchFilters();
        setMessageContent("Categoría creada. Actualizando lista...");
        setMessageType("info");
      }
      setShowMessageModal(true);
      setIsAddingCategoria(false);
      setNewCategoriaNombre("");

    } catch (error: any) {
      console.error("Error al agregar la categoria:", error);

      // Ahora puedes acceder a cualquier propiedad sin que TypeScript se queje
      const errorMessage = error.response?.data?.msg || "Ocurrió un error inesperado.";

      setMessageContent(errorMessage);
      setMessageType("error");
      setShowMessageModal(true);
    }
  };

  const handleAddNewProveedor = async () => {
    if (!newProveedorNombre.trim()) return;
    try {
      const response = await api.post("/api/proveedores/add", { nombre: newProveedorNombre, contacto: 'N/A' });
      const nuevoProveedor = response.data.proveedor; // El backend debe devolver { proveedor: {...} }

      // --- VALIDACIÓN AÑADIDA ---

      if (nuevoProveedor && nuevoProveedor._id) {
        setSuppliers([...suppliers, nuevoProveedor]);
        setProveedor(nuevoProveedor._id); // Selecciona el nuevo proveedor
        setMessageContent("Proveedor agregado exitosamente.");
        setMessageType("success");
      } else {
        fetchFilters();
        setMessageContent("Proveedor creado. Actualizando lista...");
        setMessageType("info");
      }
      setShowMessageModal(true);
      setIsAddingProveedor(false);
      setNewProveedorNombre("");

    } catch (error: any) {
      console.error("Error al agregar el proveedor:", error);

      // Ahora puedes acceder a cualquier propiedad sin que TypeScript se queje      
      const errorMessage = error.response?.data?.msg || "Ocurrió un error inesperado.";

      setMessageContent(errorMessage);
      setMessageType("error");
      setShowMessageModal(true);
    }
  };

  const handleAddNewMarca = async () => {
    if (!newMarcaNombre.trim()) return;
    try {
      const response = await api.post("/api/marcas/add", { nombre: newMarcaNombre });
      const nuevaMarca = response.data.marca; // El backend debe devolver { marca: {...} }

      // --- VALIDACIÓN AÑADIDA ---
      if (nuevaMarca && nuevaMarca._id) {
        setBrands([...brands, nuevaMarca]);
        setMarca(nuevaMarca._id); // Selecciona la nueva marca
        setMessageContent("Marca agregada exitosamente.");
        setMessageType("success");
      } else {
        fetchFilters();
        setMessageContent("Marca creada. Actualizando lista...");
        setMessageType("info");
      }
      setShowMessageModal(true);
      setIsAddingMarca(false);
      setNewMarcaNombre("");
      
    } catch (error: any) {
      console.error("Error al agregar la marca:", error);

      // Ahora puedes acceder a cualquier propiedad sin que TypeScript se queje
      const errorMessage = error.response?.data?.msg || "Ocurrió un error inesperado.";

      setMessageContent(errorMessage);
      setMessageType("error");
      setShowMessageModal(true);
    }
  };

  // Agrega esta función dentro del componente ProductList, después de las demás funciones
  const handleExportToExcel = async () => {
    try {
      setIsLoading(true)
      
      // Construir los parámetros de filtro
      const params = new URLSearchParams()
      if (filterSucursal) params.append('sucursal', filterSucursal)
      if (filterCategoria) params.append('categoria', filterCategoria)
      if (filterMarca) params.append('marca', filterMarca)
      if (filterProveedor) params.append('proveedor', filterProveedor)
      if (searchTerm) params.append('searchTerm', searchTerm)

      const response = await apiProductos.get(`/api/productos/export?${params.toString()}`, {
        responseType: 'blob' // Importante para descargar archivos
      })

      // Crear un enlace temporal para descargar el archivo
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `inventario_${new Date().toISOString().split('T')[0]}.xlsx`)
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)

      setMessageContent("Inventario exportado exitosamente.")
      setMessageType("success")
      setShowMessageModal(true)
    } catch (error) {
      console.error('Error al exportar:', error)
      setMessageContent("Error al exportar el inventario.")
      setMessageType("error")
      setShowMessageModal(true)
    } finally {
      setIsLoading(false)
    }
  }

  const handleToggleInventariado = (productId: string, currentState: boolean, productName: string) => {
    if (currentState) {
      // Si está marcado, preguntar si desea reiniciar el estado
      openConfirmationModal(
        `¿Desea reiniciar el estado de inventario del producto "${productName}"? Esto le permitirá volver a inventariarlo con una nueva fecha de última revisión.`,
        () => {
          updateInventariadoState(productId, false);
        }
      );
    } else {
      // Si no está marcado, simplemente marcar como inventariado
      updateInventariadoState(productId, true);
    }
  };

  const updateInventariadoState = (productId: string, inventariado: boolean) => {
    apiProductos
      .patch(`/api/productos/${productId}/inventariado`, { inventariado })
      .then(() => {
        setMessageContent(
          inventariado 
            ? "Producto marcado como inventariado" 
            : "Estado de inventario reiniciado correctamente"
        )
        setMessageType("success")
        setShowMessageModal(true)
        
        // Refrescar los productos
        fetchProducts(currentPage, filters)
      })
      .catch((error) => {
        setMessageContent("Error al actualizar el estado de inventariado")
        setMessageType("error")
        setShowMessageModal(true)
      })
  };

  return (
    <div className="p-4 max-w-7xl mx-auto">
      {isLoading && <Loader />}
      <ConfirmationModal
        isOpen={modalOpen}
        title="Confirmación"
        message={modalMessage}
        onConfirm={modalAction || closeModal}
        onCancel={closeModal}
        isProcessing={isSaving}
      />

      <MessageModal
        isOpen={showMessageModal}
        message={messageContent}
        messageType={messageType}
        onClose={handleCloseMessageModal}
      />

      {/* Excel Upload */}
      {userData?.role !== "vendedor" && (
        <div className="mb-6">
          <div
            onClick={() => setShowUploadExcel(!showUploadExcel)}
            className="flex items-center justify-between cursor-pointer text-[#2d53da] hover:underline select-none"
          >
            <span className="font-medium">
              ¿Tienes tu inventario en Excel?
            </span>
            {showUploadExcel ? <FaChevronUp /> : <FaChevronDown />}
          </div>

          {showUploadExcel && (
            <div className="mt-4">
              <UploadExcel onUploadSuccess={() => fetchProducts(currentPage, {
                searchTerm,
                sucursal: filterSucursal || undefined,
                categoria: filterCategoria || undefined,
                marca: filterMarca || undefined,
                proveedor: filterProveedor || undefined,
                referenciaProveedor: referenciaProveedorFilter || undefined,
              })} />
            </div>
          )}
        </div>
      )}

      {/* Page Header */}
      <PageHeader
        title="Gestión de Inventario"
        subtitle="Administra los productos de tu inventario"
        icon={FaBoxOpen}
        actions={[
          ...(userData?.role !== "vendedor" ? [
            {
              label: "Descargar Inventario",
              onClick: handleExportToExcel,
              icon: FaFileExcel,
              variant: "success" as const,
              disabled: isLoading
            },
            {
              label: "Agregar Producto",
              onClick: handleAddProduct,
              icon: FaPlus,
              variant: "primary" as const
            }
          ] : [])
        ]}
      />

      {/* Search and Filters */}
      <div className="bg-white rounded-lg p-0 mb-6 border border-gray-200 shadow-sm">
        <div className="p-4">
          <div className="flex items-center gap-3">
            {/* Búsqueda principal */}
            <div className="flex-1 relative">
              <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
              <input
                type="text"
                placeholder="Buscar por código o nombre del producto..."
                onChange={handleSearchChange}
                className="w-full pl-11 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                ref={searchInputRef}
              />
            </div>

            {/* Botón de filtros */}
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className={`flex items-center gap-2 px-5 py-3 rounded-xl font-medium transition-all ${
                isExpanded 
                  ? 'bg-blue-600 text-white shadow-lg shadow-blue-200' 
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <FaFilter className="text-sm" />
              <span>Filtros</span>
              {filterCount > 0 && (
                <span className="bg-white text-blue-600 text-xs font-bold px-2 py-0.5 rounded-full">
                  {filterCount}
                </span>
              )}
            </button>

            {/* Botón limpiar filtros */}
            {hasActiveFilters && (
              <button
                onClick={clearFilters}
                className="flex items-center gap-2 px-4 py-3 bg-red-50 text-red-600 rounded-xl font-medium hover:bg-red-100 transition-all"
              >
                <FaTimes className="text-sm" />
                <span className="hidden sm:inline">Limpiar</span>
              </button>
            )}
          </div>

          {/* Tags de filtros activos */}
          {hasActiveFilters && (
            <div className="flex flex-wrap gap-2 mt-3">
              {filterSucursal && (
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-100 text-blue-700 rounded-lg text-sm font-medium">
                  <span>Sucursal:</span>
                  <span className="font-semibold">{sucursales.find(s => s._id === filterSucursal)?.nombre}</span>
                  <button onClick={() => setFilterSucursal('')} className="ml-1 hover:bg-blue-200 rounded-full p-0.5">
                    <FaTimes className="text-xs" />
                  </button>
                </span>
              )}
              {filterProveedor && (
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-100 text-blue-700 rounded-lg text-sm font-medium">
                  <span>Proveedor:</span>
                  <span className="font-semibold">{suppliers.find(s => s._id === filterProveedor)?.nombre}</span>
                  <button onClick={() => { setFilterProveedor(''); setReferenciaProveedorFilter(''); }} className="ml-1 hover:bg-blue-200 rounded-full p-0.5">
                    <FaTimes className="text-xs" />
                  </button>
                </span>
              )}
              {filterCategoria && (
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-100 text-blue-700 rounded-lg text-sm font-medium">
                  <span>Categoría:</span>
                  <span className="font-semibold">{categories.find(c => c._id === filterCategoria)?.nombre}</span>
                  <button onClick={() => setFilterCategoria('')} className="ml-1 hover:bg-blue-200 rounded-full p-0.5">
                    <FaTimes className="text-xs" />
                  </button>
                </span>
              )}
              {filterMarca && (
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-100 text-blue-700 rounded-lg text-sm font-medium">
                  <span>Marca:</span>
                  <span className="font-semibold">{brands.find(b => b._id === filterMarca)?.nombre}</span>
                  <button onClick={() => setFilterMarca('')} className="ml-1 hover:bg-blue-200 rounded-full p-0.5">
                    <FaTimes className="text-xs" />
                  </button>
                </span>
              )}
              {filterInventariado && (
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-100 text-blue-700 rounded-lg text-sm font-medium">
                  <span>Estado:</span>
                  <span className="font-semibold">{filterInventariado === 'true' ? 'Inventariados' : 'No inventariados'}</span>
                  <button onClick={() => setFilterInventariado('')} className="ml-1 hover:bg-blue-200 rounded-full p-0.5">
                    <FaTimes className="text-xs" />
                  </button>
                </span>
              )}
              {referenciaProveedorFilter && (
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-100 text-blue-700 rounded-lg text-sm font-medium">
                  <span>Ref. Proveedor:</span>
                  <span className="font-semibold">{referenciaProveedorFilter}</span>
                  <button onClick={() => setReferenciaProveedorFilter('')} className="ml-1 hover:bg-blue-200 rounded-full p-0.5">
                    <FaTimes className="text-xs" />
                  </button>
                </span>
              )}
            </div>
          )}
        </div>

        {/* Panel de filtros expandible */}
        <div className={`transition-all duration-300 ease-in-out ${isExpanded ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'} overflow-hidden`}>
          <div className="px-4 pb-4 border-t border-gray-100">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 pt-4">
              {/* Sucursal */}
              <div className="relative group">
                <label className="block text-xs font-semibold text-gray-600 mb-1.5 ml-1">Sucursal</label>
                <div className="relative">
                  <FaBuilding className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                  <select
                    value={filterSucursal}
                    onChange={(e) => setFilterSucursal(e.target.value)}
                    className="w-full pl-10 pr-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all appearance-none cursor-pointer"
                  >
                    <option value="">Todas</option>
                    {sucursales.map((s) => (
                      <option key={s._id} value={s._id}>{s.nombre}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Proveedor */}
              <div className="relative group">
                <label className="block text-xs font-semibold text-gray-600 mb-1.5 ml-1">Proveedor</label>
                <div className="relative">
                  <FaShoppingCart className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                  <select
                    value={filterProveedor}
                    onChange={(e) => {
                      setFilterProveedor(e.target.value);
                      if (!e.target.value) setReferenciaProveedorFilter("");
                    }}
                    className="w-full pl-10 pr-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all appearance-none cursor-pointer"
                  >
                    <option value="">Todos</option>
                    {suppliers.map((s) => (
                      <option key={s._id} value={s._id}>{s.nombre}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Referencia Proveedor (Condicional) */}
              {filterProveedor && (
                <div className="relative group">
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5 ml-1">Ref. Proveedor</label>
                  <div className="relative">
                    <FaTag className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                    <input
                      type="text"
                      placeholder="Referencia..."
                      value={referenciaProveedorFilter}
                      onChange={(e) => setReferenciaProveedorFilter(e.target.value)}
                      className="w-full pl-10 pr-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    />
                  </div>
                </div>
              )}

              {/* Categoría */}
              <div className="relative group">
                <label className="block text-xs font-semibold text-gray-600 mb-1.5 ml-1">Categoría</label>
                <div className="relative">
                  <FaTags className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                  <select
                    value={filterCategoria}
                    onChange={(e) => setFilterCategoria(e.target.value)}
                    className="w-full pl-10 pr-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all appearance-none cursor-pointer"
                  >
                    <option value="">Todas</option>
                    {categories.map((c) => (
                      <option key={c._id} value={c._id}>{c.nombre}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Marca */}
              <div className="relative group">
                <label className="block text-xs font-semibold text-gray-600 mb-1.5 ml-1">Marca</label>
                <div className="relative">
                  <FaTag className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                  <select
                    value={filterMarca}
                    onChange={(e) => setFilterMarca(e.target.value)}
                    className="w-full pl-10 pr-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all appearance-none cursor-pointer"
                  >
                    <option value="">Todas</option>
                    {brands.map((b) => (
                      <option key={b._id} value={b._id}>{b.nombre}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Estado */}
              <div className="relative group">
                <label className="block text-xs font-semibold text-gray-600 mb-1.5 ml-1">Estado</label>
                <div className="relative">
                  <FaBoxOpen className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                  <select
                    value={filterInventariado}
                    onChange={(e) => setFilterInventariado(e.target.value)}
                    className="w-full pl-10 pr-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all appearance-none cursor-pointer"
                  >
                    <option value="">Todos</option>
                    <option value="true">Inventariados</option>
                    <option value="false">No inventariados</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Indicador de resultados */}
        <div className="text-gray-400 text-xs mt-1 px-4 pb-4">
          {hasActiveFilters ? (
            <span>Mostrando resultados filtrados ({filterCount} filtro{filterCount !== 1 ? 's' : ''} activo{filterCount !== 1 ? 's' : ''})</span>
          ) : (
            <span>Mostrando todos los productos</span>
          )}
        </div>
      </div>

      {/* Statistics Dashboard */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <StatsCard
          title="Cantidad Productos"
          value={totalProductos.toString()}
          description={
            <>
              <span className="font-semibold text-gray-900">
                {(totalCantidadUnidades || 0).toLocaleString()}
              </span>
              <span className="text-gray-500"> unidades totales</span>
            </>
          }
          icon={FaBox}
          gradient={false}
        />

        <StatsCard
          title="Total Compra"
          value={`$${totalCompra ? totalCompra.toLocaleString() : 0}`}
          description="Total de costo de compra"
          icon={FaArrowDown}
          gradient={false}
        />

        <StatsCard
          title="Total Venta"
          value={`$${totalValorFiltrado ? totalValorFiltrado.toLocaleString() : 0}`}
          description="Total de ventas potenciales"
          icon={FaArrowUp}
          gradient={false}
        />

        <StatsCard
          title="Total Ganancia"
          value={`$${totalGanancia ? totalGanancia.toLocaleString() : 0}`}
          description="Total ganancia estimada"
          icon={FaCoins}
          gradient={false}
        />
      </div>

      {/* Products Table */}
      <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6">
        {productos.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    <div className="flex items-center gap-2">
                      <span>Inventariado</span>
                      <div className="relative group">
                        <FaQuestionCircle className="text-gray-400 hover:text-gray-600 cursor-help transition-colors" />
                        <div className="absolute left-0 top-6 w-64 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-10">
                          <p className="font-semibold mb-1">Control de Inventario</p>
                          <p className="text-gray-300 leading-relaxed">
                            Marca los productos que ya fueron revisados físicamente. Al marcar un producto, se registra la fecha de última revisión para llevar un control preciso del inventario.
                          </p>
                          <div className="absolute -top-1 left-4 w-2 h-2 bg-gray-900 transform rotate-45"></div>
                        </div>
                      </div>
                    </div>
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Nombre
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Cantidad/Peso
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Valor Compra
                  </th>
                  {userData?.organization?.responsableIVA && (
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      % IVA
                    </th>
                  )}
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Margen de Ganancia (%)
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Valor Venta
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {productos.map((product) => (
                  <tr key={product._id} className="hover:bg-gray-50 transition-colors duration-150">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex flex-col gap-1">
                        <div className="flex items-center gap-2">
                          <input
                            type="checkbox"
                            checked={product.inventariado || false}
                            onChange={(e) => handleToggleInventariado(product._id, product.inventariado || false, product.nombre)}
                            className="w-5 h-5 text-[#2d53da] border-gray-300 rounded focus:ring-[#2d53da] cursor-pointer"
                            disabled={userData?.role === "vendedor"}
                          />
                          <div className="flex flex-col">
                            {product.inventariado ? (
                              <>
                                <span className="text-sm font-medium text-green-600">
                                  ✓ Inventariado
                                </span>
                                {product.fechaInventariado && (
                                  <div className="flex flex-col">
                                    <span className="text-xs text-gray-500">
                                      Última revisión:
                                    </span>
                                    <span className="text-xs text-gray-600 font-medium">
                                      {new Date(product.fechaInventariado).toLocaleDateString('es-CO', { 
                                        year: 'numeric', 
                                        month: 'short', 
                                        day: 'numeric' 
                                      })}
                                    </span>
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="flex flex-col">
                                <span className="text-xs text-gray-600 leading-tight">
                                  No inventariado
                                </span>
                                <span className="text-[10px] text-gray-400 italic leading-tight">
                                  Marcar si ya fue revisado
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                    <div className="flex items-center">
                      <div className="flex-shrink-0 h-10 w-10 bg-[#2d53da]/10 rounded-full flex items-center justify-center">
                        <FaBox className="text-[#2d53da]" />
                      </div>
                      <div className="ml-4">
                        <div className="flex items-center gap-2">
                          {product.categoria && (
                              <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-800">
                                  {product.categoria.nombre}
                              </span>
                          )}
                          {product.marca && (
                            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-800">
                              {product.marca.nombre}
                            </span>
                          )}
                        </div>
                        <div className="text-sm font-medium text-gray-900 mt-1" style={{ whiteSpace: 'normal' }}>
                          {product.nombre}
                        </div>
                        <div className="flex items-center gap-2">
                          <div className="text-sm text-gray-500">Código: {product.codigo}</div>
                        </div>
                        {/* Este bloque solo se muestra si el producto tiene una referencia de proveedor */}
                        {product.referenciaProveedor && (
                          <div className="flex items-center gap-2">
                            <div className="text-sm text-gray-500">
                              Ref. Proveedor: {product.referenciaProveedor}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="flex items-center">
                        {product.unidadMedida === "kg" && <FaWeight className="mr-1 text-gray-500" />}
                        {product.unidadMedida === "unidad" && <FaBoxOpen className="mr-1 text-gray-500" />}
                        {product.unidadMedida === "gramo" && <FaWeight className="mr-1 text-gray-500" />} {/* mismo ícono que kg */}
                        {product.unidadMedida === "litro" && <FaTint className="mr-1 text-gray-500" />}    {/* ícono de líquido */}
                        {product.unidadMedida === "metro" && <FaRuler className="mr-1 text-gray-500" />}   {/* ícono de medida */}
                        <span>{product.cantidad} {product.unidadMedida}</span>
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="flex items-center">
                        <FaMoneyBillWave className="mr-1 text-green-500" /> $
                        {(product.valorCompra ?? 0).toLocaleString()}
                      </span>
                    </td>
                    {userData?.organization?.responsableIVA && (
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="flex items-center">
                          <FaPercentage className="mr-1 text-blue-500" />{" "}
                          {product.ivaPorcentaje ? `${product.ivaPorcentaje}%` : "N/A"}
                        </span>
                      </td>
                    )}
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="flex items-center">
                        <FaChartLine className="mr-1 text-purple-500" /> {product.margenGanancia}%
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className="flex items-center font-medium text-gray-900">
                        <FaMoneyBillWave className="mr-1 text-green-600" /> $
                        {(product.valorVentaTotal ?? 0).toLocaleString()}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <div className="flex space-x-2">
                        <button
                          className="bg-blue-100 text-blue-600 hover:bg-blue-200 p-2 rounded-full transition-colors duration-200"
                          onClick={() => handleViewProduct(product)}
                          title="Ver detalles"
                        >
                          <FaEye />
                        </button>
                        {userData?.role !== "vendedor" && (
                          <button
                            className="bg-yellow-100 text-yellow-600 hover:bg-yellow-200 p-2 rounded-full transition-colors duration-200"
                            onClick={() => handleEditProduct(product)}
                            title="Editar producto"
                          >
                            <FaEdit />
                          </button>
                        )}
                        {userData?.role !== "vendedor" && (
                          <button
                            className="bg-red-100 text-red-600 hover:bg-red-200 p-2 rounded-full transition-colors duration-200"
                            onClick={() => handleDeleteProduct(product._id)}
                            title="Eliminar producto"
                          >
                            <FaTrash />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-12 px-2 text-center">
            <div className="bg-gray-100 p-4 rounded-full mb-3">
              <FaBox className="text-gray-400 text-3xl" />
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-1">No se encontraron productos</h3>
            <p className="text-gray-500 mb-4">Intenta con otra búsqueda o agrega un nuevo producto</p>
            <button
              onClick={handleAddProduct}
              className="flex items-center px-4 py-2 bg-[#2d53da] hover:bg-[#2d53da]/90 text-white rounded-lg transition-colors duration-200"
            >
              <FaPlus className="mr-2" /> Agregar Producto
            </button>
          </div>
        )}
      </div>

      {/* Pagination */}
      <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />

      {/* Product Modal */}
      <ReusableModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false)
          setIsReadOnlyMode(false)
        }}
        title={isReadOnlyMode ? "Ver Producto" : isEditMode ? "Editar Producto" : "Agregar Producto"}
        fields={[
          {
            label: "Sucursal",
            value: sucursal,
            onChange: setSucursal,
            required: true,
            type: "select",
            options: sucursales.map((s) => ({ value: s._id, label: s.nombre })),
            error: sucursalError,
            readOnly: isReadOnlyMode,
          },
          {
            label: "Nombre",
            value: nombre,
            onChange: setNombre,
            required: true,
            error: nombreError,
            readOnly: isReadOnlyMode,
          },
          {
            label: (
              <div className="flex justify-between items-center w-full">
                <span className="flex items-center gap-1">
                  Código <span className="text-red-500">*</span>
                </span>
                {!isReadOnlyMode && (
                  <button
                    onClick={() => setIsQRScannerOpen(true)}
                    className="text-blue-600 hover:underline text-xs flex items-center gap-1"
                  >
                    <FaBarcode className="text-base" />
                    Escanear QR
                  </button>
                )}
              </div>
            ),
            value: codigo,
            onChange: setCodigo,
            error: codigoError,
            readOnly: isReadOnlyMode,
          },
          {
            label: (
              <div className="flex items-center gap-2">
                <span>Unidad de Medida</span>
                <div className="relative group">
                  <span
                    className="text-gray-400 cursor-pointer"
                    title="Unidad: productos que se cuentan uno a uno (camisas, cajas). Kg: por peso en kilogramos (carne, arroz). Gramo: pesos pequeños (especias, joyería). Litro: líquidos (aceite, bebidas). Metro: longitud (tela, cable)."
                  >
                    <FaQuestionCircle />
                  </span>
                </div>
              </div>
            ),
            value: unidadMedida,
            onChange: (val: string) => setUnidadMedida(val as 'unidad' | 'kg' | 'gramo' | 'litro' | 'metro'),
            type: "select" as const,
            options: [
              { value: 'unidad', label: 'Unidad' },
              { value: 'kg', label: 'Kilogramo (Kg)' },
              { value: 'gramo', label: 'Gramo (g)' },
              { value: 'litro', label: 'Litro (L)' },
              { value: 'metro', label: 'Metro (m)' },
            ],
            required: true,
            readOnly: isReadOnlyMode,
          },
          {
            label: cantidadValorLabel,
            value: cantidad?.toString() || "",
            onChange: (val: string) => {
              let sanitized = val.replace(/[^0-9.,]/g, "").replace(/,/g, ".")

              // Si la unidad es "unidad", solo acepta enteros
              if (unidadMedida === "unidad") {
                sanitized = sanitized.replace(/\..*/, "") // Elimina todo después del punto
              } else {
                // Solo permite un punto decimal
                sanitized = sanitized.replace(/(\..*?)\..*/g, "$1")
              }

              setcantidad(sanitized)
            },
            required: true,
            error: cantidadError,
            readOnly: isReadOnlyMode,
            type: "text",
          },
          {
            label: (
              <div className="flex items-center gap-2">
                <span>{umbralLabel}</span>
                <div className="relative group">
                  <span
                    className="text-gray-400 cursor-pointer"
                    title="Cantidad mínima en inventario antes de recibir una alerta de stock bajo. Ej: umbral = 10 significa que te avisamos cuando queden 10 unidades o menos. Este campo es opcional."
                  >
                    <FaQuestionCircle />
                  </span>
                </div>
              </div>
            ),
            value: umbral.toString(),
            onChange: handleUmbralChange,
            readOnly: isReadOnlyMode,
          },
          {
            label: valorCompraLabel,
            value: (valorCompra ?? "").toString(),
            onChange: (val: string) => setValorCompra(Number(handleNumericInput(val))),
            required: true,
            error: valorCompraError,
            readOnly: isReadOnlyMode,
          },
          ...ivaFields,
          ...gananciaFields,
          {
            label: "Fecha de Caducidad",
            value: fechaCaducidad,
            onChange: setFechaCaducidad,
            type: "date",
            error: fechaCaducidadError,
            readOnly: isReadOnlyMode,
          },
          {
            label: (
              <div className="flex justify-between items-center w-full">
                Categoría
                {!isReadOnlyMode && (
                  <button
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); setIsAddingCategoria(true); }}
                    className="text-blue-600 hover:underline text-xs flex items-center gap-1"
                  >
                    <FaPlus /> Agregar
                  </button>
                )}
              </div>
            ),
            value: categoria,
            onChange: setCategoria,
            type: "select",
            options: categories.map((c) => ({ value: c._id, label: c.nombre })),
            readOnly: isReadOnlyMode,
          },
          {
            label: (
              <div className="flex justify-between items-center w-full">
                Proveedor
                {!isReadOnlyMode && (
                  <button
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); setIsAddingProveedor(true); }}
                    className="text-blue-600 hover:underline text-xs flex items-center gap-1"
                  >
                    <FaPlus /> Agregar
                  </button>
                )}
              </div>
            ),
            value: proveedor,
            onChange: (val: string) => {
              setProveedor(val);
              if (!val) {
                setReferenciaProveedor("");
              }
            },
            type: "select",
            options: suppliers.map((s) => ({ value: s._id, label: s.nombre })),
            readOnly: isReadOnlyMode,
          },
          ...(proveedor ? [{
            label: "Referencia de Proveedor",
            value: referenciaProveedor,
            onChange: setReferenciaProveedor,
            readOnly: isReadOnlyMode,
          }] : []),
          {
            label: (
              <div className="flex justify-between items-center w-full">
                Marca
                {!isReadOnlyMode && (
                  <button
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); setIsAddingMarca(true); }}
                    className="text-blue-600 hover:underline text-xs flex items-center gap-1"
                  >
                    <FaPlus /> Agregar
                  </button>
                )}
              </div>
            ),
            value: marca,
            onChange: setMarca,
            type: "select",
            options: brands.map((b) => ({ value: b._id, label: b.nombre })),
            readOnly: isReadOnlyMode,
          },
        ]}
        onSave={handleSaveProduct}
        saveButtonText={isEditMode ? "Guardar Cambios" : "Agregar Producto"}
        readOnlyMode={isReadOnlyMode}
      />
      <ReusableModal
        isOpen={isAddingCategoria}
        onClose={() => setIsAddingCategoria(false)}
        title="Agregar Nueva Categoría"
        fields={[
          {
            label: "Nombre de la Categoría",
            value: newCategoriaNombre,
            onChange: setNewCategoriaNombre,
            required: true,
          },
        ]}
        onSave={handleAddNewCategoria}
        saveButtonText="Guardar Categoría"
      />

      <ReusableModal
        isOpen={isAddingProveedor}
        onClose={() => setIsAddingProveedor(false)}
        title="Agregar Nuevo Proveedor"
        fields={[
          {
            label: "Nombre del Proveedor",
            value: newProveedorNombre,
            onChange: setNewProveedorNombre,
            required: true,
          },
          // Puedes añadir más campos si tu backend lo requiere, como contacto, etc.
        ]}
        onSave={handleAddNewProveedor}
        saveButtonText="Guardar Proveedor"
      />

      <ReusableModal
        isOpen={isAddingMarca}
        onClose={() => setIsAddingMarca(false)}
        title="Agregar Nueva Marca"
        fields={[
          {
            label: "Nombre de la Marca",
            value: newMarcaNombre,
            onChange: setNewMarcaNombre,
            required: true,
          },
        ]}
        onSave={handleAddNewMarca}
        saveButtonText="Guardar Marca"
      />
      {isQRScannerOpen && (
        <QRScanner
          onScanSuccess={(code: string) => {
            setCodigo(code)
          }}
          onClose={() => setIsQRScannerOpen(false)}
        />
      )}
    </div>
  )
}

export default ProductList